var ARROW_START_DEG = 133;
var ARROW_END_DEG = 406;
var ARROW_DIFF_DEG = ARROW_END_DEG - ARROW_START_DEG;
var DONUT_DASH_LENGTH = 107;
var MAX_CIRCLE_POINT = 80.5;
var MAX_SCORE = 10;

export { ARROW_DIFF_DEG, ARROW_END_DEG, ARROW_START_DEG, DONUT_DASH_LENGTH, MAX_CIRCLE_POINT, MAX_SCORE };
